import TableConfigViewModelT from '@/ViewModels/Views/TableConfigViewModel';
import ViewFactory from '@/Factories/ViewFactory';
import ComponentManager from '@/Management/ComponentManager';
export default class TableConfigViewFactory extends ViewFactory {
    public viewModel: any;
    public view: any;
    private TableConfigViewModel: any;
    private TableConfigView: any;
    constructor(params: any) {
        super(params);
        this.TableConfigViewModel = ComponentManager.getViewModel<typeof TableConfigViewModelT>('TableConfigViewModel');
        this.TableConfigView = ComponentManager.getView('TableConfigView');
    }
    public getRegion(): string {
        return 'Modal';
    }
    public getView(): any {
        if (this.viewModel == null) {
            this.viewModel = new this.TableConfigViewModel({
                locator: this.locator,
                viewFactory: this
            });
        }
        if (this.view == null) {
            this.view = new this.TableConfigView(this.viewModel, this.createRootElement('TableConfig'));
        }
        let tuple = this.view.getTuple();
        return tuple.view;
    }
}

ComponentManager.setFactory('TableConfig', TableConfigViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');